import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.8em 0 0.8em;
  line-height: 2.6em;
  margin: 1em 0 1em 0;
`;
